import { render, staticRenderFns } from "./VueItem.vue?vue&type=template&id=7b2f4088&"
import script from "./VueItem.vue?vue&type=script&lang=js&"
export * from "./VueItem.vue?vue&type=script&lang=js&"
import style0 from "./VueItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VueItem.vue"
export default component.exports